function getWeekOfMonth() {
  const date = new Date()
  const firstDay = new Date(date.getFullYear(), date.getMonth(), 1).getDay()
  const day = date.getDate()

  return Math.ceil((day + firstDay) / 7)
}

export default getWeekOfMonth
